import * as stylex from "@stylexjs/stylex";
import { pipe } from "fp-ts/lib/pipeable";
import { useRTL } from "hooks";
import { ArrowLeft14 } from "icons/ArrowLeft";
import Link from "next/link";
import { linkBody } from "../../materials/typography/links";
import { E } from "../../prelude";
import { getAliasHref, RAlias, RAliasArticle } from "../../routes";
import { HighlightByTheme } from ".";
export function PageLink({ children, name }) {
    return pipe(RAlias.decode(name), E.fold(()=><span>{children}</span>, (name_)=>{
        return pipe(RAliasArticle.decode(name_), E.fold(()=><Link href={getAliasHref(name_)} {...stylex.props(linkBody.root)}>
                {children}
              </Link>, (article)=><HighlightByTheme theme={article}>
                <span className="x1ff6pmh xz7m5ty">{children}</span>
              </HighlightByTheme>));
    }));
}
export function BackLink({ children, name }) {
    const isRTL = useRTL();
    return <PageLink name={name}>
      <ArrowLeft14 {...{
        0: {
            className: "x1rg5ohu xxymvpz x1xegmmw x1c071of"
        },
        1: {
            className: "x1rg5ohu xxymvpz x1xegmmw x19jd1h0"
        }
    }[!!isRTL << 0]}/>
      {children}
    </PageLink>;
}
